/* C/C selector: predictable, below-field menu while preserving the native
 * select as the source of truth for the theme's variant controller. */
(function () {
  'use strict';

  function init(root) {
    if (root.dataset.chdSizeSelectInitialized) return;
    var select = root.querySelector('select.product-form__single-selector');
    var trigger = root.querySelector('.chd-handle-size-select__trigger');
    var label = root.querySelector('.chd-handle-size-select__trigger-label');
    var menu = root.querySelector('.chd-handle-size-select__menu');
    var options = root.querySelectorAll('.chd-handle-size-select__option');
    if (!select || !trigger || !label || !menu || !options.length) return;

    root.dataset.chdSizeSelectInitialized = 'true';
    root.classList.add('chd-handle-size-select--enhanced');
    trigger.id = select.id + '-trigger';
    menu.id = select.id + '-listbox';
    trigger.setAttribute('aria-controls', menu.id);
    menu.setAttribute('aria-labelledby', trigger.id);
    options.forEach(function (option) { option.tabIndex = -1; });

    function close() {
      trigger.setAttribute('aria-expanded', 'false');
      menu.hidden = true;
    }

    function sync() {
      var selected = select.options[select.selectedIndex];
      label.textContent = selected ? selected.textContent.trim() : '';
      options.forEach(function (option) {
        option.setAttribute('aria-selected', option.dataset.value === select.value ? 'true' : 'false');
      });
    }

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      menu.hidden = isOpen;
      if (!isOpen) {
        var current = root.querySelector('[aria-selected="true"]');
        if (current) current.focus();
      }
    });

    options.forEach(function (option) {
      option.addEventListener('click', function () {
        select.value = option.dataset.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        close();
        trigger.focus();
      });
    });

    select.addEventListener('change', sync);
    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) close();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        event.preventDefault();
        close();
        trigger.focus();
      } else if (event.key === 'Tab') {
        close();
      } else if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) !== -1) {
        event.preventDefault();
        trigger.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
        var available = Array.prototype.filter.call(options, function (option) { return !option.disabled; });
        var index = available.indexOf(document.activeElement);
        if (event.key === 'Home') index = 0;
        else if (event.key === 'End') index = available.length - 1;
        else index = (index + (event.key === 'ArrowDown' ? 1 : -1) + available.length) % available.length;
        if (available[index]) available[index].focus();
      }
    });
    sync();
  }

  function initAll() {
    document.querySelectorAll('[data-chd-handle-size-select]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
